import React, { useCallback, useEffect, useState } from "react";
import { filterOptionsMapping, renderInputs } from "./FilterOptions";

const TableauFilters = ({ activeTab, setTablueFilter, setActiveGraphType, dateRange, dropDownValues }) => {
  const [filterOptions, setFilterOptions] = useState();

  const handleChange = useCallback((filterName, newValue, key) => {
    setFilterOptions((prev) =>
      prev.map((item) => {
        if (item.filterName === filterName) {
          if (item.type === "defaultView") {
            setTablueFilter({ filterName: item?.name || null, filterValue: null });
            setActiveGraphType("bar");
            return { ...item, active: true };
          } else if (key === "active" && !newValue) {
            setTablueFilter({ filterName: null, filterValue: null });
            setActiveGraphType("bar");
          } else {
            setActiveGraphType(item.graphType);
            setTablueFilter(() => ({
              filterName: item.name,
              filterValue: key === "active" ? item.defaultValue : newValue,
            }));
          }
          return { ...item, [key]: newValue };
        }
        return { ...item, active: false };
      })
    );
  }, []);

  useEffect(() => {
    setFilterOptions(filterOptionsMapping[activeTab]);
  }, [activeTab]);

  return (
    <>
      {filterOptions?.map((item) => {
        return (
          <div
            onClick={(e) => handleChange(item.filterName, !item.active, "active")}
            key={item.id}
            className={item.active ? "active filterItem activeFilterTab" : "filterItem inActiveFilterTab"}
          >
            <div className="data">
              <p>{item.filterName}</p>
              {item.sliderTrue && item.active && item.activeInput && (
                <div onClick={(e) => e.stopPropagation()}>
                  <input
                    type="number"
                    onChange={(e) => {
                      console.log(e.maxValue);
                      let value = Number(e.target.value);
                      if (value > item.maxValue) value = item.maxValue;
                      if (value < 0) value = 0;
                      handleChange(item.filterName, value, "defaultValue");
                    }}
                    value={item.defaultValue}
                    disabled={!item.active}
                  />
                </div>
              )}
            </div>
            {item.active &&
              (item.sliderTrue || item.toggleTrue) &&
              renderInputs(item, item.type, handleChange, dateRange, dropDownValues)}
          </div>
        );
      })}
    </>
  );
};

export default TableauFilters;
